import React from 'react';
import DatePicker from '../DatePicker';
const moment = require('moment');
import * as CommonUtil from '../../common/util';
// import { DATE_FORMAT } from "../../containers/WorkkardDetail/constants";
import { DEFAULT_TIME_FORMAT } from '../../common/constants';
import Icon from '../../icons';

const FormDatePicker = (field) => (
    <div className={`colFlex ${field.wrapperClass ? field.wrapperClass : ''} ${(field.meta.touched && field.meta.error) ? 'errorMsg' : ''}`}>
        {field.label && <label>{field.label}{field.isRequired && <sup>*</sup>}
            {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
        </label>}
        <DatePicker
            minDate={field.minDate}
            maxDate={field.maxDate}
            selectedDate={field.input.value}
            id={field.id}
           // onChange={(e) =>field.input.onChange(moment(e).isValid() ? moment(e).format(DATE_FORMAT):"")}
            onChange={field.input.onChange}
            placeholderText = {field.placeholderText}
            disabled={field.disabled}
            showCalenderIcon={true}
            calendarClassName="animated faster fadeInUpx2"
            popperClassName={field.popperClassName || ""}
            inputClass={field.inputClass}
            shouldCloseOnSelect={field.shouldCloseOnSelect}
            openToDate={field.openToDate && CommonUtil.compareDate(field.input.value, moment(), DEFAULT_TIME_FORMAT) ? field.input.value : moment()}
            dateFormat={field.showTime ? DEFAULT_TIME_FORMAT :null}
            showComment={false}
            //showTimeSelect={field.showTime}
            myContainer={field.showTime}
            showTimePicker={field.showTime}
            showSysTime={field.hasOwnProperty('showSysTime') ? field.showSysTime :true}
        />
        {field.meta.touched && field.meta.error &&
            <span>{field.meta.error}</span>}
    </div>
)

export default FormDatePicker;